import jqBrowser from 'jquery.browser'

const browser = {...jqBrowser}

if (browser.mozilla) browser.firefox = true
if (browser['windows phone']) browser.windowsPhone = true

browser.versionString = browser.version
browser.version = parseInt(browser.versionNumber, 10)

/* eslint-disable no-nested-ternary */
browser.os = browser.win
  ? 'windows'
  : browser.mac
  ? 'mac'
  : browser.linux
  ? 'linux'
  : browser.ipad
  ? 'ios'
  : browser.iphone
  ? 'ios'
  : browser.android
  ? 'android'
  : browser.windowsPhone
  ? 'windowsPhone'
  : 'unknown'

browser.osTitle =
  browser.os === 'ios'
    ? 'iOS'
    : browser.os === 'unknown'
    ? 'unknown'
    : browser.os.slice(0, 1).toUpperCase() + browser.os.slice(1)

browser.title = browser.msie
  ? 'Explorer'
  : // eslint-disable-next-line no-undef
  browser.msedge || window.navigator.userAgent.includes('Edg')
  ? 'Edge'
  : browser.mozilla
  ? 'Firefox'
  : browser.name.slice(0, 1).toUpperCase() + browser.name.slice(1)

export default browser
